import React, { useEffect, useRef, useState } from "react";
import {
  addCollege,
  updateCollegeDetails,
} from "../../../Services/HomeService";
import toast from "react-hot-toast";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const CollegeUniversityStep5 = ({ data, setData, setCurrentStep, currentStep }) => {
  const initialValues = {
    feesText: data?.feesText
  }
  const [formData, setFormData] = useState(initialValues);
  const [formDataLoading, setFormDataLoading] = useState(false);

  const handleBack = (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep - 1)
  }

  const handleUpdate = async (e) => {
    e?.preventDefault();
    setCurrentStep(currentStep + 1)

    try {
      setFormDataLoading(true);
      const res = await updateCollegeDetails(data?._id, formData);
      console.log("College Add Step2 Message ", res);
      if (res?.status) {
        // toast.success(res?.message);
        setFormData(initialValues)
        setFormDataLoading(false);
        setData({
          ...data,
          feesText: formData?.feesText
        })
        setCurrentStep(currentStep + 1)
      } else {
        toast.error(res?.message);
        setFormDataLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add College.");
      console.error("Error adding College:", error);
      setFormDataLoading(false);
    }
  };

    useEffect(() => {
      setFormData(initialValues)
    }, [data])

  return (
    <>

      <section className="chartBox_area">
        <form
          onSubmit={(e) => {
            handleUpdate(e);
          }}
        >
          <div className="row d-flex justify-content-center">

            

            

            <div className="col-md-12 mt-3">
              <label htmlFor="longDescription">
                Text under fees table <span className="text-danger">*</span>
              </label>
              <ReactQuill
                modules={modules}
                theme="snow"
                value={formData?.feesText}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    feesText: value,
                  }));
                }}
                placeholder="Enter Long Description"
                style={{
                  height: "150px",
                  marginBottom: "40px",
                  fontFamily: "Poppins",
                  fontSize: "1rem"
                }}
              />
            </div>

          </div>
          <div className=" d-flex justify-content-end">
            {
              currentStep > 2 &&
              <button
                type="button"
                className="btn mt-3"
                style={{
                  background: "rgb(133, 218, 79)",
                  borderRadius: "13px",
                  marginRight: "15px"
                }}
                onClick={(e) => handleBack(e)}
              >Back
              </button>
            }

            <button
              disabled={formDataLoading}
              type="submit"
              className="btn mt-3"
              style={{
                background: "rgb(133, 218, 79)",
                borderRadius: "13px",
              }}
            >
              {formDataLoading
                ? "Saving..."
                // : "Add College/University"
                : `Save & Continue`
              }
            </button>
          </div>
        </form>
      </section>

    </>
  );
};

export default CollegeUniversityStep5;
